import type { CSSProperties } from 'react'

import SelectComponent from 'react-select'

import * as Grid from '../../shared/grid'

interface Props <T extends Record<string, unknown>> {
  options: T[]
  value?: T
  onChange: (item: T) => void
  placeholder: string
  isClearable?: boolean
  controlStyles?: CSSProperties
  indicatorSeparator?: CSSProperties
}

export function Select <T extends Record<string, unknown>> ({ options, value, placeholder, onChange, isClearable, controlStyles, indicatorSeparator }: Props<T>): JSX.Element {
  return (
    <Grid.SelectWrapper
      label={placeholder}
      data-test={placeholder}
    >
      <SelectComponent
        value={value}
        options={options}
        placeholder={placeholder}
        isClearable={isClearable}
        onChange={(item) => onChange(item as T)}
        styles={{
          control: (styles: any, { isFocused }) => ({
            ...styles,
            backgroundColor: '#fff',
            border: '1px solid #DADCE0',
            borderRadius: '4px',
            boxShadow: 'none',
            height: '2.6rem',

            outline: isFocused ? '#5404FF solid 2px' : 'none',
            minWidth: 'max-content',
            ...controlStyles
          }),
          container: (styles: any) => ({
            ...styles,
            flex: 1,
            backgroundColor: '#F6F6F6',
            boxShadow: 'none',
            borderRadius: '8px'
          }),
          indicatorSeparator: (styles: any) => ({
            ...styles,
            marginBottom: 0,
            marginTop: 0,

            ...indicatorSeparator
          }),
          dropdownIndicator: (styles: any) => ({
            ...styles,
            padding: '0 18px'
          })
        }}
      />
    </Grid.SelectWrapper>
  )
}
